import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted} from 'vue'
import moment, { Moment } from 'moment';

type Props = {
    meetingMoment: Moment
    name?: String
}


export default /*#__PURE__*/_defineComponent({
  __name: 'meeting-details-header',
  props: {
    meetingMoment: null,
    name: null
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    meetingMoment: Moment
    name?: String
}


// const namePassed = ref<boolean>(false)


const __returned__ = { props, ref, onMounted, moment, Moment }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})